<template>
<center>
  <div
    style="padding: 0 20px 0 20px;"
    :style="{ 
      'width': !isSimulation && isDesktop && !isForceMobile ? '800px !important' : 'auto',
    }"
  >
    <div
      v-for="(item, index) in data.ContactItems"
      :key="`mnu${index}`"
    >
      <contact-item
        :data="item"
        :customTextColorContent="customTextColorContent"
      />
      <v-divider v-if="!data.HideDivider && index < data.ContactItems.length -1" style="margin-left: 50px!important;margin-right: 50px!important;" />
    </div>
  </div>
</center>
</template>

 <script>
  import constants from '@/constants'
  import ContactItem from './ContactItem'
  import utils from '@/services/utils'
  export default {
    components: {
      ContactItem
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
      customTextColorContent : {
        type: String,
        default: null,
      },
    },
    computed: {
      locale () {
        return this.$store.state.app.locale;
      },
      isForceMobile () {
        return this.$route.query.fm === 'true'
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      date () {
        return new Date(this.data.TimelineDate)
      },
      dayOfMonth () {
        return this.date.getDate()
      },
      dayOfWeek () {
        return this.date.toLocaleString(this.locale, {  weekday: 'long' })
      },
      month () {
        return this.date.toLocaleString(this.locale, {  month: 'long' })
      },
      year () {
        return this.date.getFullYear()
      },
      isDesktop () {
        return !utils.isMobile()
      }
    }
  }
</script>
